import { Routes } from '@dtx-company/true-common/src/constants/routes'
import { useRouter } from 'next/router'

export function useIsFlowpage(): boolean {
  const { pathname } = useRouter()

  return pathname === Routes.FLOWPAGE
}
